import { render, staticRenderFns } from "./baseAside.vue?vue&type=template&id=fbfd1d10&scoped=true&"
import script from "./baseAside.vue?vue&type=script&lang=js&"
export * from "./baseAside.vue?vue&type=script&lang=js&"
import style0 from "./baseAside.vue?vue&type=style&index=0&id=fbfd1d10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfd1d10",
  null
  
)

export default component.exports